export const GET_BALANCE = 'GET_BALANCE';

